import { space } from '@op/opds.tokens';
import { ReactElement } from 'react';
import { useMessage } from '@messageformat/react';
import CourseHeader from '../CourseHeader';
import { ReactComponent as PortfolioImage } from '../../images/OP_symbolikuvitus_128_007.svg';
import TaskOne from './TaskOne';
import TaskTwo from './TaskTwo';
import TaskThree from './TaskThree';
import HighlightedList from '../HighlightedList';
import CourseComplete from '../CourseComplete';
import parseMsgContent from '../../util/parseMsgContent';
import CourseContent from '../CourseContent';
import InvestorProfiles from '../Course5/InvestorProfiles';
import { ReactComponent as TimeImage } from '../../images/OP_symbolikuvitus_128_037.svg';

const Course7 = (): ReactElement => {
  const firstIntro = useMessage('course7.courseContent.part1');
  const parsedFirstIntro = parseMsgContent(firstIntro);

  const thirdContent = useMessage('course7.courseContent.part3');
  const parsedThirdContent = parseMsgContent(thirdContent);

  const fourthContent = useMessage('course7.courseContent.part4');
  const parsedFourthContent = parseMsgContent(fourthContent);

  return (
    <div style={{ marginBottom: space.default }}>
      <CourseHeader
        courseTitleId="course7.title"
        courseHeaderText="learn_more"
        Image={PortfolioImage}
        courseNumber={7}
      />
      <CourseContent content={parsedFirstIntro} headingAs="h2" />
      <TaskOne />
      <CourseContent content={parsedThirdContent} headingAs="h2" />
      <div style={{ paddingBottom: space.xl }}>
        <InvestorProfiles isCourse7 />
      </div>
      <div style={{ paddingBottom: space.xl }}>
        <TaskTwo />
      </div>
      <TaskThree />
      <div style={{ paddingTop: space.xxs, paddingBottom: space.default }}>
        <TimeImage className="investoracademy-small-svg" aria-hidden="true" />
      </div>
      <CourseContent content={parsedFourthContent} headingAs="h2" />
      <HighlightedList
        title="course7.highlighted_message.title"
        messageId="course7.highlighted_message.body"
      />
      <CourseComplete messageId="course7.recap" />
    </div>
  );
};

export default Course7;
